import React, { useState } from 'react';
import { ShieldAlert, ArrowLeft, Lock, KeyRound } from 'lucide-react';

export function AccessDeniedView({ onAuthenticated }) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleUnlockWithPin = async (e) => {
    e.preventDefault();
    if (!pin) return;
    setLoading(true);
    setError('');

    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin: pin.trim() }),
        credentials: 'include'
      });
      const data = await res.json();
      if (res.ok && data.success && data.token) {
        localStorage.setItem('softmatek_admin_token', data.token);
        if (onAuthenticated) onAuthenticated();
        else window.location.reload();
      } else {
        setError(data.error || 'Credenciales incorrectas. Acceso denegado.');
        setLoading(false);
      }
    } catch (err) {
      setError('Error de comunicación con el servidor de autenticación.');
      setLoading(false);
    }
  };

  const handleRedirectSoftmatek = () => {
    window.location.href = 'https://softmatek.com/login?from=https://studio.softmatek.com';
  };

  const handleRedirectAdmin = () => {
    window.location.href = 'https://softmatek.com/admin';
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      width: '100vw',
      background: 'radial-gradient(ellipse at top, #0f172a 0%, #030712 100%)',
      color: '#f8fafc',
      padding: '24px',
      fontFamily: 'Inter, system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        padding: '32px',
        borderRadius: '24px',
        background: 'rgba(15, 23, 42, 0.85)',
        border: '1px solid rgba(168, 85, 247, 0.25)',
        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.6), 0 0 40px rgba(168, 85, 247, 0.1)',
        backdropFilter: 'blur(20px)',
        maxWidth: '460px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
        textAlign: 'center'
      }}>
        <div style={{
          width: '64px',
          height: '64px',
          borderRadius: '20px',
          background: 'rgba(168, 85, 247, 0.12)',
          border: '1px solid rgba(168, 85, 247, 0.3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Lock size={30} color="#c084fc" />
        </div>

        <div>
          <span style={{
            fontSize: '11px',
            textTransform: 'uppercase',
            letterSpacing: '1.5px',
            color: '#a855f7',
            fontWeight: 700
          }}>
            Softmatek AI Studio
          </span>
          <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#ffffff', marginTop: '6px' }}>
            Acceso SuperAdmin Requerido
          </h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', marginTop: '8px', lineHeight: '1.6' }}>
            Este generador utiliza APIs de alto consumo de <strong>Google Veo 3.1 & Gemini</strong>. El acceso está restringido exclusivamente a la dirección de la agencia.
          </p>
        </div>

        {/* Formulario de Desbloqueo Rápido por PIN / Password */}
        <form onSubmit={handleUnlockWithPin} style={{ width: '100%', marginTop: '4px' }}>
          <div style={{ position: 'relative', width: '100%' }}>
            <input
              type="password"
              placeholder="Contraseña o PIN Maestro..."
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px 12px 40px',
                borderRadius: '12px',
                background: 'rgba(2, 6, 23, 0.7)',
                border: error ? '1px solid #ef4444' : '1px solid rgba(148, 163, 184, 0.2)',
                color: '#ffffff',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
            <KeyRound size={16} color="#94a3b8" style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)' }} />
          </div>

          {error && (
            <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '8px', textAlign: 'left' }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              marginTop: '12px',
              padding: '12px 20px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg, #a855f7, #6366f1)',
              color: '#ffffff',
              border: 'none',
              fontSize: '13px',
              fontWeight: 700,
              cursor: 'pointer',
              boxShadow: '0 4px 15px rgba(168, 85, 247, 0.3)'
            }}
          >
            {loading ? 'Verificando...' : 'Desbloquear Estudio'}
          </button>
        </form>

        <div style={{ display: 'flex', gap: '12px', width: '100%', marginTop: '8px' }}>
          <button
            type="button"
            onClick={handleRedirectSoftmatek}
            style={{
              flex: 1,
              padding: '10px 14px',
              borderRadius: '10px',
              background: 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              color: '#cbd5e1',
              fontSize: '12px',
              cursor: 'pointer'
            }}
          >
            Login Softmatek
          </button>
          <button
            type="button"
            onClick={handleRedirectAdmin}
            style={{
              flex: 1,
              padding: '10px 14px',
              borderRadius: '10px',
              background: 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              color: '#cbd5e1',
              fontSize: '12px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px'
            }}
          >
            <ArrowLeft size={14} /> Centro de Mando
          </button>
        </div>
      </div>
    </div>
  );
}
